// extracted by mini-css-extract-plugin
module.exports = {"formLabelCell":"FormLabelCell_formLabelCell__1iX4h"};